import React from 'react';
import './SuperAdminBanner.css';
import { CustomTitle, CustomParagraph, CustomButton } from '@/components';
import { SuperAdmin } from '@/assets/icons/icons';

interface SuperAdminBannerProps {
  title?: string;
  subtitle?: string;
  onTransfer?: () => void;
  hasTransferRights?: boolean;
}

const SuperAdminBanner: React.FC<SuperAdminBannerProps> = ({
  title = 'You are the Super Admin for this account',
  subtitle,
  onTransfer,
  hasTransferRights = false,
}) => {
  return (
    <div className='banner-wrap'>
      <div className='banner-inner'>
        <SuperAdmin color={'#3D81FF'} height={24} width={24} />
        <div className='banner-copy'>
          <CustomTitle
            text={title}
            fontSize={14}
            fontWeight='600'
            lineHeight='16px'
            color='var(--text-primary)'
            marginBottom={0}
          />
          <CustomParagraph
            text={subtitle}
            fontSize='12px'
            fontWeight='400'
            lineHeight='20px'
            color='var(--text-primary)'
            marginBottom='0'
            className='banner-subtitle'
          />
          {hasTransferRights && (
            <CustomButton
              text='Transfer ownership'
              width={'137px'}
              height={'28px'}
              borderRadius={'24px'}
              bgColor='#111111'
              color='#ffffff'
              border='0px'
              fontSize={'12px'}
              fontWeight={600}
              onClick={onTransfer}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminBanner;
